"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"configurator":"style_xvGJC","cursorDefault":"style_2cQ8Q"};
tokens._getCss = function () {return `/* imported from style.css */ .style_xvGJC{ width: 100%; } .style_2cQ8Q{ cursor: default; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/components/Configurator/style_css.js"};
exports["default"] = tokens;